/**
 * Публичные параметры Keycloak из Vite-окружения (без инициализации keycloak-js).
 * По смыслу соответствует passport-client `constants/keycloak`.
 *
 * @module constants/keycloak
 */

/**
 * Базовый URL Keycloak (например `http://localhost:11100/auth`).
 *
 * @returns {string}
 * @throws {Error} если переменная не задана
 */
export function getKeycloakBaseUrl(): string {
  const raw = import.meta.env.VITE_KEYCLOAK_URL;
  if (typeof raw !== 'string' || raw.trim() === '') {
    throw new Error('VITE_KEYCLOAK_URL must be a non-empty string');
  }
  return raw.replace(/\/$/, '');
}

/**
 * Имя realm.
 *
 * @returns {string}
 * @throws {Error} если переменная не задана
 */
export function getKeycloakRealm(): string {
  const raw = import.meta.env.VITE_KEYCLOAK_REALM;
  if (typeof raw !== 'string' || raw.trim() === '') {
    throw new Error('VITE_KEYCLOAK_REALM must be a non-empty string');
  }
  return raw.trim();
}

/**
 * Client ID SPA для survey-client.
 *
 * @returns {string}
 * @throws {Error} если переменная не задана
 */
export function getKeycloakClientId(): string {
  const raw = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;
  if (typeof raw !== 'string' || raw.trim() === '') {
    throw new Error('VITE_KEYCLOAK_CLIENT_ID must be a non-empty string');
  }
  return raw.trim();
}

/**
 * Режим ответа OpenID (как в passport-client: `fragment` для hash-редиректа).
 */
export const KEYCLOAK_RESPONSE_MODE_FRAGMENT = 'fragment';
